<div class="card card-stats mb-4 mb-xl-0 h-100">
    <div class="card-body h-100 d-flex flex-column justify-content-between">
      <div class="row flex-nowrap" *ngIf="data && data.length > 0">
        <div class="col pr-0">
          <h5 class="card-title text-uppercase text-muted mb-2 {{tituloClass}}">{{titulo}}</h5>
          <div *ngFor="let item of data" style="font-size: 0.9rem;">
            <span class="font-weight-bold mr-2 text-muted">{{item.label}}</span>
  
            <span *ngIf="isNumber(item.valor)" class="font-weight-bold mr-2">{{ item.valor  | currency:'CLP' }}</span>
            <span *ngIf="!isNumber(item.valor)" class="font-weight-bold mr-2">{{item.valor}}</span>
  
            <small *ngIf="!isVacio(item.subValor)"
              class="font-weight-normal">({{ item.subValor+item.subUnidadMedida }})</small>
          </div>
        </div>
        <div class="col-auto d-flex justify-content-between flex-column">
          <div class="icon align-self-end icon-shape text-white rounded-circle shadow {{iconContainerClass}}">
            <i [class]="iconClass"></i>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="mostrarBotonDetalle && data && data.length > 0">
        <div class="col-12 text-right">
          <button class="btn btn-sm btn-link p-0" style="font-size: 0.8rem" (click)="clickDetalle.emit()">{{ textoBotonDetalle }}</button>
        </div>
      </div>
      <div *ngIf="data && data.length == 0" class="row flex-column justify-content-center align-content-center">
        <div class="text-center"><i class="fas fa-spinner fa-2x fa-spin fa-fw"></i></div>
        <div class="mt-1">Cargando</div>
      </div>
    </div>
  </div>
  